import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form";
import FormButton from "../FormButton";
import { useState, useEffect }from "react";
import { sendJNRNotification} from "../../http/HostingHttp";
import Input from "../Input";
// import { Autocomplete, TextField } from '@mui/material'

export default function JNRSendNotificationModal({ notify, handleClicked, productList, ...props }) {
  const [details, setDetails] = useState({
    domain_name: '',
    product: '',
    customer_email: '',
    description: '',
  });
  const [contacts, setContacts] = useState([]);

//   useEffect(() => {
//     if (notify) {
//         console.log(notify)
//       setDetails({
//         domain_name: notify.domain_name || '',
//         product_type: notify.product || '',
//         customer_name: '', // Assuming this is entered by user
//         description: notify.description || '',
//         price : notify.price,
//         expiry_date : notify.renewal_date
//       });
//       setContacts([{ email: notify.email || '', phone: notify.mobile || notify.phone || '' }]);
//     }
//   }, [notify]);  

useEffect(() => {
  if (notify) {
    console.log(notify)
    setDetails({
      domain_name: notify.domain_name || "",
      product_type: notify.product_type || notify.product || "",
      customer_name: notify.customer_name || "",
      description: notify.description || "",
      price: notify.price || "",
      expiry_date: notify.renewal_date || notify.expiry_date || "",
      email: notify.email || "",
    });

    setContacts([
      {
        email: notify.customer_email || notify.email || "",
        phone: notify.mobile || notify.phone || ""
      }
    ]);
  }
}, [notify]);


  function handleClose() {
    handleClicked(false);
  }

  function handleDetailChange(field, value) {
    setDetails(prev => ({ ...prev, [field]: value }));
  }

  function handleContactChange(index, field, value) {
    const updatedContacts = [...contacts];
    updatedContacts[index][field] = value;
    setContacts(updatedContacts);
  }

  function handleAddContact() {
    setContacts([...contacts, { email: "", phone: "" }]);
  }

  function handleRemoveContact(index) {
    setContacts(contacts.filter((_, i) => i !== index));
  }

  function handleSendNotification(event) {
    event.preventDefault();
    const requestBody = {
      ...details,
      sr_no: notify?.sr_no,
      emails: contacts.map(c => c.email).filter(Boolean),
      phones: contacts.map(c => c.phone).filter(Boolean),
      expiry_date : notify.renewal_date,
    };
    console.log("Sending Data:", requestBody);
    sendJNRNotification(requestBody);
    handleClicked(false)
  }

  return (
    notify && createPortal(
      <Div className="modal-backdrop">
        <dialog {...props} style={{ zIndex: 1, maxWidth: "100%" }}>
          <Div className="form-group">Send Notification</Div>
          <Form onSubmit={handleSendNotification}>
            <Div className="form-group">
              <label>Domain Name</label>
              <Input name="domain_name" onChange={(e) => handleDetailChange("domain_name", e.target.value)}
              value={details.domain_name} type="text" className="form-control" />
            </Div>
            <Div className="form-group">
              <label>Product Type</label>
              <Input value={details.product_type} name="product_type" onChange={(e) => handleDetailChange("product_type", e.target.value)} type="text" className="form-control" />
            </Div>

            <Div className="form-group">
              <label>Customer Name</label>
              <Input value={details.customer_name} name="customer_name" onChange={(e) => handleDetailChange("customer_name", e.target.value)}
              type="text" className="form-control" />
            </Div>

            <Div className="form-group">
              <label>Description</label>
              <textarea value={details.description} onChange={(e) => handleDetailChange("description", e.target.value)}
              name="description" type="text" className="form-control"  />
            </Div>

            <Div className='form-group'>
              <label>Price</label>
              <Input type='number' name="price" value={details.price} onChange={(e) => handleDetailChange("price", e.target.value)}
              className='form-control' placeholder='10'/>
            </Div>

            {contacts.map((contact, index) => (
              <Div className="form-group" key={index} style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flexGrow: 1 }}>
                  <label>Email</label>
                  <Input value={contact.email} type="text" onChange={(e) => handleContactChange(index, "email", e.target.value)} className="form-control" />
                </div>
                <div style={{ flexGrow: 1, marginLeft: "10px" }}>
                  <label>Phone</label>
                  <Input value={contact.phone} type="text" onChange={(e) => handleContactChange(index, "phone", e.target.value)} className="form-control" />
                </div>
                <FormButton type="button" onClick={() => handleRemoveContact(index)} className="btn btn-danger" style={{ marginTop: "30px", marginLeft: "10px" }}>
                  Remove
                </FormButton>
              </Div>
            ))}

            <Div className="form-group">
              <FormButton type="button" onClick={handleAddContact} className="btn btn-secondary">Add Contact</FormButton>
            </Div>

            <Div className="form-group">
              <Div className="row">
                <Div className="col-sm-6">
                  <FormButton type="submit" className="btn btn-primary submit-btn btn-block">Send Notification</FormButton>
                </Div>
                <Div className="col-sm-6">
                  <FormButton type="button" onClick={handleClose} className="btn btn-primary submit-btn btn-block">Close</FormButton>
                </Div>
              </Div>
            </Div>
          </Form>
        </dialog>
      </Div>,
      document.getElementById("modal")
    )
  );
}
